// extracted by mini-css-extract-plugin
export default {"searchContainer":"QpujnI"};